// Stessa rampa delle card "Have a look at these": raggi ~x1.7, ogni strato
// sfuma su una banda larga che si sovrappone alla successiva.
const BLUR_RADII = [0.5, 0.9, 1.5, 2.5, 4.2, 7, 11.5, 19]
const BLUR_BAND_STEP = 9
const BLUR_BAND_WIDTH = 37

export const BLUR_LAYERS = BLUR_RADII.map((blur, index) => ({
  blur,
  from: index * BLUR_BAND_STEP,
  to: index * BLUR_BAND_STEP + BLUR_BAND_WIDTH,
}))
